import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default () => (
  <svg
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="stroke-change"
      d="M23.5513 7.31141C23.7345 6.93894 24.2655 6.93894 24.4487 7.31141L28.9879 16.5417C29.4963 17.5755 30.4808 18.2929 31.6206 18.4601L41.7871 19.9516C42.1964 20.0117 42.3599 20.5146 42.064 20.8038L34.7014 28.0018C33.8795 28.8053 33.5045 29.9611 33.6981 31.094L35.434 41.2529C35.5038 41.6616 35.0744 41.9728 34.7077 41.7793L25.6338 36.9896C24.6115 36.45 23.3885 36.45 22.3662 36.9896L13.2923 41.7793C12.9256 41.9728 12.4962 41.6616 12.566 41.2529L14.3019 31.094C14.4955 29.9611 14.1205 28.8053 13.2986 28.0018L5.93599 20.8038C5.64012 20.5146 5.80356 20.0117 6.21294 19.9516L16.3794 18.4601C17.5192 18.2929 18.5037 17.5755 19.0121 16.5417L23.5513 7.31141Z"
      stroke="#CCCCCC"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
